/**
 * Zentrale Stelle für alle ausgehenden Ziele.
 *
 * Die Kontakt-Schaltflächen gehen laut Kundenvorgabe direkt per E-Mail an
 * das jeweilige Produktpostfach: alles rund um CAP an cap@, alles rund um
 * den Carrier Hub an carrier-hub@.
 */
export const links = {
  corporate: "https://www.vitroconnect.com",
  cap: "https://cap.vitroconnect.com",
  carrierhub: "https://carrierhub.vitroconnect.com",

  contactCap: "mailto:cap@vitroconnect.com",
  contactCarrierhub: "mailto:carrier-hub@vitroconnect.com",
  contactReseller: "mailto:cap@vitroconnect.com",
  contactSupplier: "mailto:cap@vitroconnect.com",
  routeQuery: "mailto:carrier-hub@vitroconnect.com",
  networkOffer: "mailto:carrier-hub@vitroconnect.com",

  imprint: "https://vitroconnect.com/de/impressum/",
  privacy: "https://vitroconnect.com/de/datenschutz/",
} as const;
